<header class="ion-header ion-hide-lg-up">
  <header-main></header-main>
</header>

<main class="ion-content" fullscreen>
  <h1 class="ion-hide-lg-up ion-text-center ion-color-white">
    Oops! Page not found
  </h1>
  <header class="ion-hide-lg-down">
    <header-desktop></header-desktop>
    <h1>
      <svg xmlns="http://www.w3.org/2000/svg" class="ion-icon" viewBox="0 0 512 512"><path d="M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z" stroke-linecap="round" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></path><path d="M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z" stroke-linecap="round" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></path><path d="M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z"></path></svg>
      Oops! Page not found
    </h1>
  </header>
  <div class="container-fluid ion-grid ion-padding">
    <div class="row">
      <div class="col col-xs-12 col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-4">
        <div class="ion-card ion-padding">
          <div class="ion-card-header ion-padding">
            <div class="ion-card-title ion-color-primary"><a href="/">Home</a></div>
          </div>
        </div>
        <div class="ion-card ion-padding">
          <div class="ion-card-header ion-padding">
            <div class="ion-card-title ion-color-primary">Company</div>
          </div>
          <div class="ion-card-content ion-padding">
            <div class="ion-item">
              <a href="/gigs">Gigs</a>
            </div>
            <div class="ion-item">
              <a href="/jobs">Jobs</a>
            </div>
            <div class="ion-item">
              <a href="/volunteers">Volunteers</a>
            </div>
            <div class="ion-item">
              <a href="/promote">Promote</a>
            </div>
          </div>
        </div>
        <div class="ion-card ion-padding">
          <div class="ion-card-header ion-padding">
            <div class="ion-card-title ion-color-primary">Support</div>
          </div>
          <div class="ion-card-content ion-padding">
            <div class="ion-item">
              <a href="/support">Help centre</a>
            </div>
            <div class="ion-item">
              <a href="/faqs">FAQs</a>
            </div>
            <div class="ion-item">
              <a href="/how-it-works">How it works</a>
            </div>
            <div class="ion-item">
              <a href="/pricing">Pricing</a>
            </div>
            <div class="ion-item">
              <a href="/categories">Categories</a>
            </div>
          </div>
        </div>
        <div class="ion-card ion-padding">
          <div class="ion-card-header ion-padding">
            <div class="ion-card-title ion-color-primary"><a href="/sitemap">Sitemap</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-footer ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
